var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_455_2273)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3857 19.1234H24.1971C26.5888 19.1234 28.905 16.7566 28.905 14.3939V4.89492C28.905 2.53216 26.5888 0.165405 24.1971 0.165405H5.32184C2.93015 0.165405 0.574219 2.53216 0.574219 4.89492V14.3939C0.574219 16.7606 2.93015 19.1234 5.32184 19.1234V26.2596L12.3857 19.1234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30139 7.59692C10.3661 7.59692 11.2004 8.43507 11.2004 9.50469C11.2004 10.5743 10.3661 11.3765 9.30139 11.3765C8.23665 11.3765 7.40234 10.5384 7.40234 9.50469C7.40234 8.47099 8.23665 7.59692 9.30139 7.59692Z",
    fill: "#3364D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3561 7.59692C21.3811 7.59692 22.2194 8.43507 22.2194 9.50469C22.2194 10.5743 21.3851 11.3765 20.3561 11.3765C19.3271 11.3765 18.457 10.5384 18.457 9.50469C18.457 8.47099 19.2913 7.59692 20.3561 7.59692Z",
    fill: "#3364D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8092 7.59692C15.8739 7.59692 16.7083 8.43507 16.7083 9.50469C16.7083 10.5743 15.8739 11.3765 14.8092 11.3765C13.7445 11.3765 12.9102 10.5384 12.9102 9.50469C12.9102 8.47099 13.7842 7.59692 14.8092 7.59692Z",
    fill: "#3364D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_455_2273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.3308,
    height: 26.0941,
    fill: "white",
    transform: "translate(0.574219 0.165405)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/sms-icon.3cbf74d275acb867b6199d1e278d1cb4.svg";
export { ForwardRef as ReactComponent };